import { QueryClient } from '@tanstack/react-query';

// Singleton QueryClient. Exported so non-component code (e.g. cacheCleanup,
// useUserStore) can invalidate or clear the React Query cache directly —
// previously this was attempted via `window.queryClient`, which was never set,
// so the cache survived logout and the next user saw the previous user's data.
export const queryClient = new QueryClient();
